<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template lang="html">
  <div class="centerx">
    <vs-popup
        class="commercial-claim-transfer-modal"
        title="Copy Commercial Claim"
        :active="visible"
        button-close-hidden
    >

      <p>The Commercial Claims from the selected Producer will be assigned to the Producer<br>you select from the dropdown below.</p>
      <br>
      <p>Note: This will overwrite their currently assigned Commercial Claims</p>
      <br>
      <vue-form-generator
          ref="form"
          :model="model"
          :schema="schema"
      />

      <div class="vx-col w-full text-right my-3">
        <vs-button class="ml-3" @click="copy" color="light">
          Copy
        </vs-button>
        <vs-button class="ml-3" @click="cancel">
          Cancel
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>

import FormModelMixin from "@/components/mixins/FormModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  props: {
    visible: {
      // using visible instead of value (v-model) because of a conflict with FormModelMixin
      type: Boolean,
      default: false
    },
    selectedProducer: {
      type: Number,
      required: true
    },
  },
  components: {
  },
  mixins: [FormModelMixin, NotificationMixin],
  data () {
    return {
      model: {
        Company_FK: {},
      },
      schema: {
        groups: [
          {
            styleClasses: "vx-row w-full",
            fields: [
              {
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "vx-col w-full",
                label: "Producer",
                model: "Company_FK",
                values: () => this.producerOptions.map(( producer ) => {
                  return {
                    id: producer.id,
                    name: `${producer.CompanyCode} - ${producer.name}`,
                  }
                }),
                selectOptions: {
                  showLabels: false,
                  hideSelected: true,
                  key: "id",
                  trackBy: "id",
                  label: "name",
                },
              },
            ]
          },
        ],
      },
      producerOptions: [],
      options: [
        {
          endpoint: () => this.$api.companies.list(),
          optionsFieldName: "producerOptions",
          nameFieldName: "CompanyName",
          idFieldName: 'id',
          additionalFields: [
              "CompanyCode",
          ],
        },
      ],
    }
  },
  methods: {
    copy() {
      if (!this.model.Company_FK.id) {
        this.notifyWarning('Please select a producer');

        return false;
      }

       return this.copyCommercialClaims(this.model.Company_FK.id);
    },
    cancel() {
      this.$emit('cancel');
    },
    async copyCommercialClaims(targetProducerId) {
      try {
        await this.$api.companies.copyCommercialClaimsTo(this.selectedProducer, targetProducerId)
        this.$emit('updated');
      } catch (e) {
        this.$emit('error', 'Error occurred. Please try again later');
        console.error(e)
      } finally {
      }
    }
  },
}

</script>

<style lang="scss">
  .vs-popup--content {
    overflow: visible;
  }
</style>
